module.exports = __webpack_public_path__ + "img/emojione-monotone_input-numbers.e1bd5234.svg";